import { formValidation, scrollToElement } from "./utils";

$(document).ready(function(){
    var $form = $('#edit-user-password');
    if(!$form.length){
        return;
    }
    
    // Form validation
    $form.submit(formValidation);
    
    // Disable duplicate submission on page reload
    if($form.hasClass('was-submitted')) {
        if(window.history.replaceState) {
            window.history.replaceState( null, null, window.location.href );
        }
        
        // Scroll to first error
        scrollToElement($form.find('.alert').first());
    }
    
});